import { render, staticRenderFns } from "./CompaniesGraph.vue?vue&type=template&id=74077b1a"
import script from "./CompaniesGraph.vue?vue&type=script&lang=js"
export * from "./CompaniesGraph.vue?vue&type=script&lang=js"
import style0 from "./CompaniesGraph.vue?vue&type=style&index=0&id=74077b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports